import { FC, SVGProps } from 'react';
import styled, { css } from 'styled-components';

import { ArrowLeftIconS } from '@lichtblick/icons/svg/arrow-left/arrow-left-s';
import { ArrowRightIconS } from '@lichtblick/icons/svg/arrow-right/arrow-right-s';
import { SmallAndAbove, Colors, Spacing, Breakpoints, MediumAndAbove, LargeAndAbove } from '@lichtblick/theme';

const commonStyles = css`
  cursor: pointer;
  position: absolute;
  top: calc(100% + 2.5rem);
  z-index: 10;
`;

type SliderNavigationButtonsProps = SVGProps<SVGSVGElement> & {
  $isDisabled: boolean;
  $numPages: { [K in Breakpoints]?: number } & { mobile: number };
};

const BULLET_WIDTH = Spacing.Xxs;
const SPACER_WIDTH = Spacing.S;
const ARROW_WIDTH = Spacing.S;

const calcOffset = (numPages: number) =>
  `(${numPages} * ${BULLET_WIDTH} + ${numPages + 1} * ${SPACER_WIDTH}) / 2 - ${ARROW_WIDTH}`;

// TODO Make this more DRY
export const PrevButton = styled<FC<SliderNavigationButtonsProps>>(ArrowLeftIconS)`
  left: calc(50% - ${({ $numPages: { mobile } }) => calcOffset(mobile)});
  ${({ $numPages: { [Breakpoints.Small]: small } }) =>
    small
      ? `@media ${SmallAndAbove} {
    left: calc(50% - ${calcOffset(small)});
    ${small <= 1 ? 'display: none;' : ''}
  }`
      : ''}
  ${({ $numPages: { [Breakpoints.Medium]: medium } }) =>
    medium
      ? `@media ${MediumAndAbove} {
    left: calc(50% - ${calcOffset(medium)});
    ${medium <= 1 ? 'display: none;' : ''}
  }`
      : ''}
  ${({ $numPages: { [Breakpoints.Large]: large } }) =>
    large
      ? `@media ${LargeAndAbove} {
    left: calc(50% - ${calcOffset(large)});
    ${large <= 1 ? 'display: none;' : ''}
  }`
      : ''}
  ${commonStyles}
  ${({ $isDisabled }) => `color: ${$isDisabled ? Colors.Gray : Colors.Black};`}
`;

export const NextButton = styled<FC<SliderNavigationButtonsProps>>(ArrowRightIconS)`
  ${commonStyles}
  ${({ $isDisabled }) => `color: ${$isDisabled ? Colors.Gray : Colors.Black};`}
  right: calc(50% - ${({ $numPages: { mobile } }) => calcOffset(mobile)});

  ${({ $numPages: { [Breakpoints.Small]: small } }) =>
    small
      ? `@media ${SmallAndAbove} {
    right: calc(50% - ${calcOffset(small)});
    ${small <= 1 ? 'display: none;' : ''}
  }`
      : ''}
  ${({ $numPages: { [Breakpoints.Medium]: medium } }) =>
    medium
      ? `@media ${MediumAndAbove} {
    right: calc(50% - ${calcOffset(medium)});
    ${medium <= 1 ? 'display: none;' : ''}
  }`
      : ''}
  ${({ $numPages: { [Breakpoints.Large]: large } }) =>
    large
      ? `@media ${LargeAndAbove} {
    right: calc(50% - ${calcOffset(large)});
    ${large <= 1 ? 'display: none;' : ''}
  }`
      : ''}
`;
